export const PARTNER_ACCOUNT_LIST_REQUEST = 'PARTNER_ACCOUNT_LIST_REQUEST';

export const SET_PARTNER_ACCOUNT_LIST = 'SET_PARTNER_ACCOUNT_LIST';

export const SET_TOTAL_COUNT = 'SET_TOTAL_COUNT';

export const SET_PARTNER_PAGINATION = 'SET_PARTNER_PAGINATION';

export const PARTNER_EMAIL_CHECK = 'PARTNER_EMAIL_CHECK';

export const CREATE_PARTNER = 'CREATE_PARTNER';

export const REMOVE_PARTNER = 'REMOVE_PARTNER';

export const PARTNER_ACCOUNT_DETAIL = 'PARTNER_ACCOUNT_DETAIL';
